import { Icon, Button, Pill } from '@iwoca/orion';

import OfferCard from '../OfferCard';

const LightningLoanOfferCard = ({
    amount,
    onSelect,
    interestRate,
    isPartnerCustomer
}: {
    amount: string;
    interestRate: string;
    onSelect: () => void;
    isPartnerCustomer: boolean;
}) => {
    return (
        <OfferCard
            testID="flexi-12-auto-offer-card"
            pills={
                <>
                    <Pill variant="green">You're approved</Pill>
                </>
            }
            title={
                isPartnerCustomer ? (
                    <h3>Flexi loan</h3>
                ) : (
                    <h3>Take the money today</h3>
                )
            }
            features={
                <ul>
                    <li>
                        <Icon icon="clockOutline" /> Instant decision - you can
                        withdraw today
                    </li>
                    <li>
                        <Icon icon="calendarOutline" /> Borrow from 1 day to 12
                        months
                    </li>
                    <li>
                        <Icon icon="userCheck" /> No documents required
                    </li>
                </ul>
            }
            details={
                <ul>
                    <li>
                        Confirmed amount <span>{amount}</span>
                    </li>

                    <li>
                        Monthly interest <span>{interestRate}%</span>
                    </li>
                </ul>
            }
            button={
                <Button variant="primary" onClick={onSelect}>
                    Accept right now
                </Button>
            }
        />
    );
};

export default LightningLoanOfferCard;
